<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 24 24"
  fill="none"
>
  <g clip-path="url(#clip0_2911_18534)">
    <path
      d="M22.4762 2.66629H1.52383C0.68231 2.66629 0 3.34856 0 4.19008V19.8092C0 20.6506 0.68231 21.3329 1.52383 21.3329H22.4762C23.3177 21.3329 24.0001 20.6506 24.0001 19.8091V4.19008C24.0001 3.34856 23.3178 2.66629 22.4762 2.66629ZM22.4762 4.19008V15.2723L19.4731 12.5421C19.0217 12.1318 18.3276 12.1482 17.8964 12.5798L14.8571 15.6186L8.8644 8.46054C8.41142 7.91958 7.5817 7.91426 7.12192 8.44873L1.52383 14.9546V4.19008H22.4762ZM16 8.19008C16 7.03274 16.9379 6.09483 18.0952 6.09483C19.2526 6.09483 20.1905 7.03274 20.1905 8.19008C20.1905 9.34742 19.2526 10.2853 18.0952 10.2853C16.9379 10.2853 16 9.34742 16 8.19008Z"
      [attr.fill]="color"
    />
  </g>
  <defs>
    <clipPath id="clip0_2911_18534">
      <rect width="24.0001" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>
